import { recordTrack } from '@saucelabs/sl-util-segmentio';
import { EVENT_CATEGORY } from '@saucelabs/sl-util-segmentio/lib/constants';

export const TRACKING_AREA = 'Automated';
export const TRACKING_SUB_AREA_DEFAULT = 'Builds';

export const BUILDS_EVENTS = Object.freeze({
  BUILDS_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate to Builds Page',
  }),
  TOGGLE_FAILED_JOBS: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Toggle Failed Jobs',
  }),
  VIEW_BUILD: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate to Builds Detail Page',
  }),
  VIEW_BUILDS_DOCS: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'View Builds Docs',
  }),
  DESELECT_STATUS_FILTER: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Clear Status Filter',
  }),
  owner: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Owner Filter',
  }),
  status: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Status Filter',
  }),
});

export const trackEvent = ({ category, name, metadata }) => {
  recordTrack(category, {
    subject_name: name,
    ...metadata,
  });
};

/**
 * trackEventWrapper for trackEvent function
 * @param {object} metadata
 * @returns {function} a function that accepts event and eventPayload as arguments
 * @param {object} event
 * @param {object} eventPayload
 * @returns {undefined}
 */
export const trackEventWrapper = (metadata) => (event, eventPayload) => {
  trackEvent({
    ...event,
    metadata: {
      ...(typeof eventPayload === 'object' ? eventPayload : null),
      ...metadata,
    },
  });
};
